// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
  
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     // Get the token from localStorage (or wherever you're storing it)
//     const token = localStorage.getItem('access_token');

//     // Clone the request and add the Authorization header if the token exists
//     if (token) {
//       const clonedRequest = req.clone({
//         setHeaders: {
//           Authorization: `Bearer ${token}`  // Attach the token in the Authorization header
//         }
//       });
//     //   console.log("** IN INTERCEPT!! **");

//       // Pass the cloned request to the next handler
//       return next.handle(clonedRequest);
//     }

//     // If no token, pass the request without modification
//     return next.handle(req);
//   }
// }

import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }
  return next(req);
};

